"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAllGuardState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const selectAllGuard_1 = require("../behavior/selectAllGuard");
const util_1 = require("../util");
const SELECT_ALL_GUARD_THRESHOLD = 200;
/**
 * Tracks the "are you sure you want to wipe the document?" prompt that
 * appears when the user triggers Backspace / Delete / typing while the entire
 * document is selected.
 */
class SelectAllGuardState {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.open = ui_1.rsync.val(false);
        this.pending = ui_1.rsync.val(null);
        this.start = () => () => { };
        this.guard = (action) => {
            const { mutxt } = this;
            if (mutxt.readOnly.value)
                return false;
            const editor = mutxt.editor;
            if (!(0, selectAllGuard_1.isFullDocSelected)(editor))
                return false;
            if ((0, util_1.getEditorPlainText)(editor).length < SELECT_ALL_GUARD_THRESHOLD)
                return false;
            this.pending.set(action);
            this.open.set(true);
            return true;
        };
        this.requestDelete = () => this.guard({ kind: 'delete' });
        this.requestReplaceWithText = (text) => this.guard({ kind: 'replace-text', text });
        this.requestReplaceWithFragment = (fragment) => this.guard({ kind: 'replace-fragment', fragment });
        this.confirm = () => {
            const action = this.pending.value;
            this.close();
            if (!action)
                return;
            const { mutxt } = this;
            const { editor } = mutxt;
            if (action.kind === 'delete') {
                (0, selectAllGuard_1.resetDocumentContent)(editor);
            }
            else if (action.kind === 'replace-text') {
                (0, selectAllGuard_1.resetDocumentContent)(editor, action.text);
            }
            else {
                (0, selectAllGuard_1.resetDocumentContent)(editor);
                editor.insertFragment(action.fragment);
            }
            mutxt.api.focus();
        };
        this.cancel = () => {
            this.close();
            this.mutxt.api.focus();
        };
        this.close = () => {
            if (this.open.value)
                this.open.set(false);
            if (this.pending.value)
                this.pending.set(null);
        };
    }
}
exports.SelectAllGuardState = SelectAllGuardState;
